<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Cont MySMIS"></SketchBreadcrumb>
        <div class="padding-box flex columnMobile space-between">
            <div class="mysmis white-box">
                <img src="@/assets/images/M3/M3Sketch/mysmis.png" class="pt-2 pb-5">
                <p class="mb-3">Apelul de proiecte pentru “Investiții în activități productive” este unul competitiv,
                    cu depunere continuă până la data închiderii apelulului.</p>

                <p class="mb-3">Cererile de finanţare se vor depune prin aplicaţia electronică MySMIS2014, cu toate anexele solicitate prin Ghidul Solicitantului.
                    Modalităţile de utilizare a aplicaţiei MySMIS2014 sunt publicate pe site-urile</p>

                <span><a href="https://2014.mysmis.ro">2014.mysmis.ro</a> &nbsp; | &nbsp; <a href="https://www.mfe.gov.ro">www.mfe.gov.ro</a></span>


                <p class="mt-3 mb-3">Înainte de demararea completării conţinutului Cererii de finanţare,
                    solicitanţii au obligaţia înregistrării în sistem, conform indicaţiilor furnizate
                    pe site-urile mai sus meníonate. Odată cu înregistrarea solicitantului, este necesară
                    completarea tuturor câmpurilor, întrucât informaţiile din aceaste secţiuni sunt esenţiale
                    pentru verificarea eligibilităţii solicitantului sau pentru evaluarea tehnico-economică.</p>

                <p>Cererea de finanțare se încarcă de către solicitant în MySMIS, în conformitate cu structura
                    prezentată în Anexa 1 a Ghidului și ținând cont de precizările Ghidului.</p>
            </div>
            <div class="tutoriale white-box">
                <div class="title">Tutorial - creare cont MySmis</div>
                <div class="tutorial">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/z85TW_DmguE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <b-form-checkbox
                        v-model="tutorial1"
                        switch
                        size="lg"
                        class="switch-box"
                        @change="completeTutorial(1)"
                    >Am creat contul MySMis</b-form-checkbox>
                </div>
                <div class="title mt-5">Tutorial - adaugare companie la cont</div>
                <div class="tutorial">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/yXZWnexlN8c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <b-form-checkbox
                        v-model="tutorial2"
                        switch
                        size="lg"
                        class="switch-box"
                        @change="completeTutorial(2)"
                    >Am adaugat compania</b-form-checkbox>
                </div>
                <div class="title mt-5">Descarcă manuale de utilizare MFE</div>
                <div class="manuale">
                    <div>
                        <a href="/documents/Manual_de_utilizare_MySMIS2014_FO_Contractare_26.05.2021.pdf" class="manual" download>
                            <b-icon-download
                                font-scale="1.4"
                                style="margin-right: 15px; color: #969ba7;"
                            ></b-icon-download>
                            <p>Modul Contractare</p>
                        </a>
                    </div>
                    <div>
                        <a href="/documents/Manual_de_utilizare_MySMIS2014_FO_GC_Cereri_de_finantare_26.05.21.pdf" class="manual" download>
                            <b-icon-download
                                font-scale="1.4"
                                style="margin-right: 15px; color: #969ba7;"
                            ></b-icon-download>
                            <p>Modul Cereri de finanțare</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="deschiderea-proiectului white-box">
                <div class="title">Deschiderea proiectului în MySmis</div>
                <iframe width="450" height="250" src="https://www.youtube.com/embed/5r4VULpvLIs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <p>După deschiderea apelului de proiecte pentru “Investiții în activități productive” te rugăm să te loghezi în MySMIS și să adaugi proiectul tău. Ter rugăm mai apoi să introduci mai jos codul SMIS. Acest cod este necesar în întocmirea documentelor de aplicare (Anexe)</p>
                <div class="flex align-center flex-column">
                    <p class="mt-4">Sistemul MySMIS este:</p>
                    <p class="m-0" style="text-indent: 0;"><span class="red">Închis</span></p>
                    <p class="mt-4">Titlul recomandat al proiectului tău:</p>
                    <b-form-input v-model="titlu"></b-form-input>
                    <p class="mt-4">Codul tău SMIS:</p>
                    <b-form-input v-model="codSmis" class="cod-input" :class="codSmisError ? 'error-input' : ''" ></b-form-input>
                    <div class="blue-button" @click="sendMySmisData()">Validează cod SMIS</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BFormCheckbox, BIconDownload, BFormInput} from 'bootstrap-vue'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    export default {
        components: {
            SketchBreadcrumb,
            BFormCheckbox,
            BIconDownload,
            BFormInput,
        },
        data() {
            return {
                titlu: 'Investiții în activități productive pentru '+JSON.parse(localStorage.getItem('currentM3Company')).name,
                codSmis: '',
                tutorial1: false,
                tutorial2: false,
                mysmis: false,
                codSmisError: false,
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        mounted() {
            if(localStorage.getItem('currentM3Company')){
                axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                    .then( response => {
                        this.tutorial1 = JSON.parse(response.data).mySmisTutorial1;
                        this.tutorial2 = JSON.parse(response.data).mySmisTutorial2;
                        if(this.allData && this.allData.m3_project && this.allData.m3_project.mysmis){
                            this.titlu = this.allData.m3_project.mysmis.title
                            this.codSmis = this.allData.m3_project.mysmis.code
                        }

                        this.section = {
                            section: 'cont-mysmis'
                        }

                        if(this.tutorial1 && this.tutorial2 && this.codSmis !== ''){
                            this.$emit('addToProgress', this.section)
                        } else{
                            this.$emit('removeFromProgress', this.section)
                        }
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
            }

        },
        methods: {
            completeTutorial(event) {
                axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                    .then( response => {
                        let checks = JSON.parse(response.data);
                        if(event === 1){
                            checks.mySmisTutorial1 = this.tutorial1;
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                            this.formSend = {
                                is_mysmis_account_added: this.tutorial1
                            }

                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', this.formSend)
                                .then((response) => {
                                    this.$toast.success(response.data);
                                })
                        } else{
                            checks.mySmisTutorial2 = this.tutorial2;
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                            this.formSend = {
                                is_mysmis_company_added: this.tutorial2
                            }

                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', this.formSend)
                                .then((response) => {
                                    this.$toast.success(response.data);
                                })
                        }
                        this.section = {
                            section: 'cont-mysmis'
                        }
                        if(this.tutorial1 && this.tutorial2 && this.codSmis !== ''){
                            this.$emit('addToProgress', this.section)
                        } else{
                            this.$emit('removeFromProgress', this.section)

                        }
                    })

            },
            sendMySmisData() {
                this.mysmis = {
                    mysmis: {
                        title: this.titlu,
                        code: this.codSmis
                    }
                }
                if(this.codSmis === '' || this.codSmis === null){
                    this.$toast.error('Codul SMIS este obligatoriu')
                    this.codSmisError = true
                    return;
                }
                this.codSmisError = false
                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', this.mysmis)
                    .then((response) => {
                        this.$toast.success(response.data);
                        this.section = {
                            section: 'cont-mysmis'
                        }
                        if(this.tutorial1 && this.tutorial2 && this.codSmis !== ''){
                            this.$emit('addToProgress', this.section)
                        } else{
                            this.$emit('removeFromProgress', this.section)
                        }
                    })
                    .finally(() => this.$emit('achizitiiChanged'))
            }
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
    height: max-content;
    min-height: 800px;
}
.mysmis{
    width: 100%;
    max-width: 360px;
    text-align: center;
    height: 100%;
}
.error-input{
    border-color: red !important;
}
.mysmis p{
    text-indent: 35px;
    font-size: 12px;
    font-weight: 500;
    color: #5b6276;
}
.mysmis span{
    color: #9a9da7;
    font-size: 12px;
    font-weight: 500;
}
.mysmis span a{
    color: inherit;
}
.tutoriale{
    width: 100%;
    height: 100%;
}
.tutorial{
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}
.manuale{
    display: flex;
    flex-direction: column;
    margin-top: 30px;
}
.tutorial iframe {
    width: 100%;
    max-height: 200px;
}
.tutorial .switch-box{
    width: 100%;
    margin-top: 10px;
}
 .title{
    color: #5b6276;
    font-size: 14px;
    font-weight: 600;
}
.manual{
    display: flex;
    text-decoration: none;
    margin-bottom: 15px;
    align-items: center;
}
.manuale p{
    font-size: 12px;
    color: #5b6276;
    font-weight: 500;
}
.switch-box{
    margin-left: 20px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.deschiderea-proiectului{
    width: 100%;
    height: 100%;
}
.deschiderea-proiectului iframe{
    width: 100%;
    margin-top: 20px;
    margin-bottom: 50px;
    max-height: 200px;
}
.deschiderea-proiectului p{
    font-size: 12px;
    font-weight: 500;
    color: #5b6276;
}
.red{
    color: #ff5050;
    font-weight: 800;
    font-size: 16px;
}
input{
    border-radius: 0;
    font-size: 13px;
    margin: 5px 0;
    color: #9da2b3;
    text-align: center;
}
input:focus{
    color: #9da2b3;
}
.cod-input{
    font-size: 27px;
    letter-spacing: 6px;
}
.blue-button{
    cursor: pointer;
    margin-top: 20px;
    font-size: 12px;
    background: #01e8c6;
    color: #5b6276;
    max-width: 180px;
    padding: 4px 0;
    text-align: center;
    width: 100%;
}
.blue-button:hover{
    color: #fff;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
@media (max-width: 1800px){
    .columnMobile{
        flex-direction: column;
    }
    .mysmis, .deschiderea-proiectului{
        width: 100%;
        max-width: 100%;
        min-height: inherit;
        margin-bottom: 15px;
    }
}
</style>
